module.exports = __webpack_public_path__ + "static/media/schody43 - schody drewniane nakladane.35185549.jpg";